import { useQuery } from "@tanstack/react-query";
import useCacheMutation from "~hooks/useCacheMutation";
import { getClientSearch, getClientSearchFile, getReflex, getSearchs, saveSearchs } from "~services/ResearchManagementServices";

export const useGetPesquisaCliente = (idPesquisa) => {
  const data = useQuery(
    ["dataResearchManagement", idPesquisa],
    () => getClientSearch(idPesquisa),
    {
      onSuccess: () => {},
      staleTime: 0,
      cacheTime: 0,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );

  return data;
};

export const useGetPesquisaClienteFile = (idPesquisa, fileNome) => {
  const data = useQuery(
    ["dataResearchManagementFile", idPesquisa, fileNome],
    () => getClientSearchFile(idPesquisa, fileNome),
    {
      enabled: !!fileNome,
      onSuccess: () => {},
      staleTime: 0,
      cacheTime: 0,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );

  return data;
};

export const useGetPesquisasClientes = () => {
  const data = useQuery(
    ["dataResearchsManagement"],
    () => getSearchs(),
    {
      onSuccess: () => {},
      staleTime: 0,
      cacheTime: 0,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );

  return data;
};

export const useGetReflexVendedores = () => {
  const data = useQuery(
    ["dataResearchsManagementReflex"],
    () => getReflex(),
    {
      onSuccess: () => {},
      staleTime: 0,
      cacheTime: 0,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );

  return data;
};

export const useSalvarPesquisaCliente = (pesquisas, customOnSuccess, customOnError) => {
  const { mutateCached } = useCacheMutation(
    saveSearchs,
    "Salvar Pesquisa",
    null,
    null,
    null,
    customOnSuccess,
    customOnError
  );

  const handleSave = () => {
    mutateCached(pesquisas);
  };

  return handleSave;
};

